import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
});

// Token fallback (in case cookies fail due to cross-site)
const TOKEN_KEY = 'tf_token';
export const setStoredToken = (t) => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
};
export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);

// Active-location fallback. The backend ALSO accepts a `tf_active_rid` cookie,
// but that cookie is SameSite=Lax — and in production the SPA at
// clickmeniu.ro talks to a different origin (clickmeniu-api.onrender.com), so
// Lax cookies are NOT attached to XHR. Without this header, multi-location
// owners click "switch" and the backend never sees their preference. Mirror
// the token-fallback pattern: store in localStorage, inject as header on
// every request.
const ACTIVE_RID_KEY = 'tf_active_rid';
export const setStoredActiveRid = (rid) => {
    if (rid) localStorage.setItem(ACTIVE_RID_KEY, rid);
    else localStorage.removeItem(ACTIVE_RID_KEY);
};
export const getStoredActiveRid = () => localStorage.getItem(ACTIVE_RID_KEY);

api.interceptors.request.use((cfg) => {
    const t = getStoredToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    const rid = getStoredActiveRid();
    if (rid) cfg.headers['X-Restaurant-Id'] = rid;
    return cfg;
});

// 402 = backend says this location has no active subscription. Bounce the user
// to the Plan tab so they can pay. Skip on routes that legitimately return 402
// (none today — but keep `paywall_seen` so we don't redirect-loop the settings
// page itself if it 402s for some other reason).
api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 402) {
            try {
                sessionStorage.setItem('tf_paywall_msg', err?.response?.data?.detail || 'Abonament expirat sau inactiv pentru această locație.');
                const here = window.location.pathname + window.location.search;
                if (!here.startsWith('/r/settings')) {
                    window.location.assign('/r/settings?paywall=1#plan');
                }
            } catch {}
        }
        return Promise.reject(err);
    },
);

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || 'A apărut o eroare';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        return detail.map((e) => {
            if (!e || typeof e !== 'object') return String(e);
            const loc = Array.isArray(e.loc) ? e.loc.filter((p) => p !== 'body').join('.') : '';
            const msg = typeof e.msg === 'string' ? e.msg : JSON.stringify(e);
            return loc ? `${loc}: ${msg}` : msg;
        }).join(' ');
    }
    if (detail && typeof detail.msg === 'string') return detail.msg;
    return String(detail);
}
